const LEGACY_STORE_TERMS = /dripwest|westside|hoodie|hoodies|streetwear|pharma palace|pharmapalace|medicine|fleece|garment[- ]dyed|outerwear|tees\b|tee\b/i;

export function isLegacyStoreContent(record) {
    if (!record) return false;
    const values = [record.title, record.name, record.slug, record.category, record.author, record.subject, record.description, record.excerpt, record.subtitle, record.body, record.content, record.product_slug, record.code, record.key, record.label, record.value];
    const searchable = values.map((value) => typeof value === "string" ? value : JSON.stringify(value || "")).join(" ");
    return LEGACY_STORE_TERMS.test(searchable);
}
